import React, { useMemo } from "react";
import { motion } from "framer-motion";
import Parser from 'html-react-parser';
import { truncateText } from "../utils/wordsLimit";
import AboutVideo from "./formation-single-pages/shared-components/AboutVideo";

export default function WebinaireCard({ webinaire }) {
    const {
        id,
        name = "",
        introduction = "",
        lien = "",
        date = "",
        image = "",
        isPassed,
        idLinkRepaly
    } = webinaire || {};

    const webinaireId = `${id}`;
    const truncatedTitle = useMemo(() => truncateText(name, 30, 10, 2), [name]);
    const truncatedDescription = useMemo(() => truncateText(introduction, 20, 19, 2), [introduction]);

    return (
        <motion.div
            className="news-block col-lg-3 col-md-6 col-sm-12"
            layout
            initial={{ opacity: 0.6, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
        >
            <div className="inner-box">
                <div className="image-box">
                    <figure className="image">
                        {image ? (
                            <img
                                src={image}
                                alt={name}
                                className="lazy"
                                width="100%"
                                height="auto"
                            />
                        ) : (
                            <img
                                src="/images/background/stand-illustration.jpg"
                                alt={name}
                                className="lazy"
                                width="100%"
                                height="auto"
                            />
                        )}
                    </figure>
                </div>

                <div className="lower-content homepage">
                    <h3 className="raleway layout-pt-5">
                        <a href={lien}
                           title={name}>
                            {truncatedTitle}
                        </a>
                    </h3>
                    <div className="text nunito">
                        {Parser(truncatedDescription)}
                    </div>
                    <div className="d-flex align-items-center mb-30">
                        <i className="icon flaticon-calendrier"  style={{ fontSize: '20px' }}></i>
                        <span className="read-more2">
                            {Parser(date)}
                        </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        {isPassed ? (
                           <AboutVideo button={'Voir le replay'} idLink={idLinkRepaly}/>
                        ) : (
                            <a href={lien}
                               className="theme-btn btn-style-one small text-center w-100">
                                Je participe à ce webinaire
                            </a>
                        )}
                    </div>

                </div>
            </div>
        </motion.div>
    );
}
